export default __webpack_public_path__ + "static/media/alert.fb05b05d.svg";